const visibleElementsOnScroll = {
  init: function () {
    this.listInfos = document.querySelector('.list-infos-malette')
    this.wrapperTestimony = document.querySelector('.wrapper-testimony')
    this.wrapperRond = document.querySelector('.image-poule-oeuf')
    this.elementArray = [this.listInfos, this.wrapperTestimony, this.wrapperRond]
    this.checkIfVisible()
  },
  checkIfVisible: function () {

    let i = 0;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (i < this.elementArray.length) {
            entry.target.classList.contains('list-infos-malette') && entry.target.classList.add('visible')
            entry.target.classList.contains('wrapper-testimony') && animeTestimony.play()
            entry.target.classList.contains('image-poule-oeuf') && animeRond.play()
          }
          i++;
        }
      })
    })
    this.elementArray.forEach(el => {
      observer.observe(el)
    })
  },
}



const animeTestimony = window.anime.timeline({
  easing: 'easeOutSine',
  duration: 800,
  delay: 100,
  autoplay: false,
}).add({
  targets: '.wrapper-testimony .one',
  opacity: 1,
}).add({
  targets: '.wrapper-testimony .three',
  opacity: 1,
}).add({
  targets: '.wrapper-testimony .five',
  opacity: 1,
})

const animeRond = window.anime.timeline({
  easing: 'easeOutSine',
  duration: 400,
  delay: 600,
  autoplay: false,
}).add({
  targets: '.image-poule-oeuf .rond-brun',
  opacity: 1,
  right: '125px',
}).add({
  targets: '.image-poule-oeuf .rond-bleu',
  opacity: 1,
  right: '-195px',
}).add({
  targets: '.image-poule-oeuf .rond-vert',
  opacity: 1,
  right: '-175px',
})

visibleElementsOnScroll.init()


// WEBPACK FOOTER //
// ./scripts/anime.js